import { Grid, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  getFullName,
  Method,
  updateMainHeader,
} from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { Header } from "../../../Components/Header/Header";
import WSStaticDataGrid from "../../../Components/StaticDataGrid/StaticDataGrid";
import { GridColDef } from "@mui/x-data-grid";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import ConfirmationPopup, {
  IMethodAction,
} from "../../../Components/Confirmation/Confirmation";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import AddIcon from "@mui/icons-material/Add";
import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";
import WSButton from "../../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const WalletsList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [walletListData, setWalletListData] = useState<any>([
    { id: "123", walletOwner: "abc" },
  ]);
  const dispatch = useDispatch();
  // AllPermissions.getInstance();
  //const { add,edit,remove, view} =AllPermissions.getCallPermission;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [action, setAction] = useState<IMethodAction>("DELETE");
  const [apiUrl, setApiUrl] = useState<any>(null);
  const [bodyData, setBodyData] = useState<any>(null);
  const { showMessage } = useSnackbar();
  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const [productSource, setProductSource] = useState<any>({
    url: "Wallet/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [
      // {
      //   field: "UpdatedAt",
      //   direction: "desc",
      // },
    ],
  });

  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "Wallet/search",
      page: 1,
      pageSize: 10,
      filter: [],
      sort: [
        {
          field: "UpdatedAt",
          direction: "desc",
        },
      ],
    };
    switch (value) {
      case "In Stock":
        soureFilter.filter = [
          {
            field: "name",
            operator: "eq",
            value: "In Stock",
          },
        ];
        break;
    }
    //  setProductSource({ ...soureFilter });
  };
  
  const source = {
    url: "Wallet/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [
      {
        field: "TransactionDate",
        direction: "desc",
      },
    ],
  };

  useEffect(() => {
    updateMainHeader("Wallet ");
  });

  breadCrumbsStore.updateBreadCrumbs([{ "Wallet List": "/wallet/list" }]);

  // useEffect(() => {
  //     const getWallets = async () => {
  //         try {

  //             const response: any = await callAPI('Wallet/all', Method.GET, null, null);
  //             // if (Array.isArray(response)) {
  //             // const updatedwallets = response.map((item: any) => ({
  //             //     ...item,
  //             //     leadName: getFullName(item?.lead?.firstName, item?.lead?.lastName, ''),
  //             // }));

  //             setWalletListData(response || []);
  //             // }
  //         }
  //         catch (e) {
  //         }
  //     }
  //     getWallets();
  // }, [])

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Lock") {
      setAction("POST");
      setApiUrl(`Wallet/lock/walletId?=${row?.id}`);
      setSelectedId(null); // Set the ID of the row to be deleted
      setPopupOpen(true);
      setBodyData({});
    } else if (action === "Unlock") {
      setAction("POST");
      setApiUrl(`Wallet/unlock/walletId?=${row?.id}`);
      setSelectedId(null); // Set the ID of the row to be deleted
      setPopupOpen(true);
      setBodyData({});
    }
  };

  // const columns: GridColDef[] = [
  //     {
  //         field: 'walletOwner',
  //         headerName: 'First name',
  //         width: 150,
  //         sortable: true

  //     },
  //     {
  //         field: 'name',
  //         headerName: 'First name',
  //         width: 150,
  //         sortable: true

  //     },
  //     {
  //         field: 'test',
  //         headerName: 'First name',
  //         width: 150,
  //         sortable: true

  //     },
  //     {
  //         field: 'actions',
  //         headerName: 'Actions',
  //         width: 120,
  //         sortable: false,
  //         filterable: false,
  //         renderCell: (params) => (
  //             <>
  //                 <Tooltip title="Edit">
  //                     <IconButton >
  //                         <EditIcon fontSize="small" />
  //                     </IconButton>
  //                 </Tooltip>
  //                 <Tooltip title="Delete">
  //                     <IconButton >
  //                         <DeleteIcon fontSize="small" />
  //                     </IconButton>
  //                 </Tooltip>
  //             </>
  //         )
  //     }

  // ];
  const columns: IColumns[] = [
    {
      header: "Owner",
      fieldName: "userName",
      type: "default",
      //  sortable: true
    },
    {
      header: "Type",
      fieldName: "type",
      type: "default",
    },
    {
      header: "Amount",
      fieldName: "amount",
      tooltip: true,
      //  isHide: isMobile,
      type: "default",
    },
    {
      header: "Refference",
      fieldName: "referenceId",
      tooltip: true,
      //  isHide: isMobile,
      type: "default",
    },
    {
      header: "Date",
      fieldName: "transactionDate",
      //  isHide: isMobile,
      type: "date",
    },
    // {
    //     header: "Is Locked",
    //     fieldName: "locked",
    //     // isHide: isMobile,
    //     type: "default",
    // },
    {
      header: "Status",
      fieldName: "status",
      //    isHide: isMobile,
      type: "status",
    },

    // {
    //     header: "Actions",
    //     fieldName: "actions",
    //     type: "action",
    //     actions: ["Lock", "Unlock"].filter(Boolean),
    //     actionCallback: (action, row) => handleAction(action, row),
    //     hideSelectedActions: {
    //         fieldToHide: [
    //             {
    //                 field: 'locked',
    //                 hideValue: ['No'],
    //                 hideActions: ['Unlock']
    //             },
    //             {
    //                 field: 'locked',
    //                 hideValue: ['Yes'],
    //                 hideActions: ['Lock']
    //             }
    //         ]
    //     }

    // },
  ];

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.locked = item?.isLocked ? "Yes" : "No";
        // item.phoneNumber = `${item?.customer?.phoneNumber}`;
        // item.doctorName = `${item?.doctor?.user?.name}`;
      });
      return data;
    }
  };
  const handleConfirm = (response: any) => {
    dispatch(resetDataComponent("walletListGrid"));
    showMessage(response?.message, response?.success ? "success" : "error");
  };
  return (
    <Grid p={3}>
      {/* <Header type="simple" isDivider={true} title="Wallets" id={'walletHeader'} headerSx={{ paddingBottom: 1, backgroundColor: '#499426', color: '#fff', }} /> */}
      {/* <Grid container spacing={2}>

                <Grid item xs={12}>
                    <WSDataGrid
                        id="walletListGrid"
                        title="Wallets"
                        columns={columns}
                        source={productSource}
                        transFormData={transFormData}
                        searchBox={{ fieldName: 'referenceId' }}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />

                    <WSStaticDataGrid
                        id="walletGrid"
                        title="Wallets"
                        columns={columns}
                        data={walletListData}

                    />
                </Grid>
                {apiUrl !== null && <ConfirmationPopup
                    apiUrl={apiUrl}
                    id={selectedId!}
                    confirmMessage="Are you sure you want to continue?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={handleConfirm}
                    type={action}
                    bodyData={bodyData}
                />}
            </Grid> */}

      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          {productSource && (
            <WSDataGridNew
              id="walletListGrid"
              title="Wallets"
              columns={columns}
              source={productSource}
              transFormData={transFormData}
              searchBox={{ fieldName: "referenceId" }}
              addButton={{ label: "New", color: "secondary" }}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
          {apiUrl !== null && (
            <ConfirmationPopup
              apiUrl={apiUrl}
              id={selectedId!}
              confirmMessage="Are you sure you want to continue?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleConfirm}
              type={action}
              bodyData={bodyData}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
